<template>
  <div class="header fixed" :class="{ scrolled: isScrolled }">
    <div class="container header-inner">
      <div class="header-left">
        <div class="logo">
          <router-link to="/">
          <div class="logo-box">
            <img :src="logoBY" width="48" alt="logo" />
            <div class="logo-text-box">
              <span class="logo-text">豹眼背调</span>
              <span class="logo-text-zm">baoyanbd.com</span>
            </div>
          </div>
          </router-link>
        </div>
        <nav class="nav-menu">
          <router-link v-for="item in navItems" :key="item.path" :to="item.path" class="nav-item" active-class="active"
            :exact="item.path === '/'">
            {{ item.label }}
          </router-link>
        </nav>
      </div>
      <div class="user-area">
        <button class="button-container call-button" type="button">
          <span class="icon-container-bg"></span>
          <span class="icon-container">
            <span class="phone">
              <svg width="15" height="17" viewBox="0 0 15 17">
                <path
                  d="M-37.64-900.53a8.685,8.685,0,0,1-2.75-.7.9.9,0,0,0-1.073.248l-1.746,2.025a14.143,14.143,0,0,1-4.951-5.748l1.744-2.026a1.313,1.313,0,0,0,.214-1.252,12.939,12.939,0,0,1-.6-3.185.815.815,0,0,0-.744-.831h-3.208a1.11,1.11,0,0,0-1,1.212c0,.018,0,.037.007.055.533,8.513,6.389,15.318,13.722,15.936a1.072,1.072,0,0,0,1.093-1.05q0-.049,0-.1v-3.4c0-.8-.314-1.157-.712-1.19"
                  transform="translate(51.757 912)" class="svg-icon" />
              </svg>
            </span>
          </span>
          <span class="word">400-9669-857</span>
        </button>

        <a href="https://www.baoyanbd.com/admin" target="_blank" class="btn-login">登录</a>
        <a href="https://www.baoyanbd.com/admin/register?inviteSaleId=100" target="_blank" class="btn-register">注册</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SiteHeader',
  data() {
    return {
      // logoScroll: require('@/assets/images/logo_scroll.png'),
      // logoWhite: require('@/assets/images/logo.png'),
      isScrolled: false,
      // logoBY: require('@/assets/images/logo.png'),
      logoBY: require('@/assets/images/logo_yun2.png'),
      navItems: [
        { label: '首页', path: '/' },
        { label: '场景使用', path: '/industry' },
        { label: '产品与服务', path: '/service' },
        { label: '关于我们', path: '/about' }
      ]
    }
  },
  mounted() {
    this.handleScroll()
    window.addEventListener('scroll', this.handleScroll, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 0
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  transition: background-color 0.3s;

  &.scrolled {
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

    .nav-item {
      // color: #333;
      color: #212121;

      &:hover,
      &.active {
        // color: rgba(51, 51, 51, 0.7);
        color: #000;
        font-weight: 700;
      }
    }

    .button-container {
      color: #3784ff;
      border-color: #dfe2eb;
    }

    .word {
      color: #3784ff;
    }
  }
}

.header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 72px;
}

.header-left {
  display: flex;
  align-items: center;
}

.logo {
  margin-right: 28px;

  img {
    display: block;
    height: auto;
  }
}

.nav-menu {
  display: flex;
  align-items: center;
}

.nav-item {
  padding: 26px 28px 24px;
  font-size: 16px;
  // font-weight: 600;
  color: #212121;
  letter-spacing: 1px;
  line-height: 22px;
  transition: color 0.3s;
  outline: none;           // 去掉焦点边框
  text-decoration: none;   // 确保没有下划线

  &:focus-visible {
    outline: none;         // 针对 focus-visible 也去掉
  }

  &:hover,
  &.active {
    // color: rgba(255, 255, 255, 0.7);
    color: #000;
    font-weight: 700;
  }
}

.user-area {
  display: flex;
  align-items: center;
}

.button-container {
  position: relative;
  box-sizing: content-box;
  width: 157px;
  height: 40px;
  padding: 0 5px;
  font-size: 16px;
  line-height: 40px;
  letter-spacing: -0.08px;
  // color: #fff;
  color: #3784ff;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 22px;
  background: transparent;
  overflow: hidden;
  outline: none;
  cursor: pointer;
  transition: border-color 0.3s ease;

  &:hover {
    // color: red;
  //   border-color: #dfe2eb;
  border: 1px solid #dfe2eb;
  }
}

.icon-container-bg {
  position: absolute;
  left: 4px;
  top: 50%;
  width: 32px;
  height: 32px;
  border-radius: 20px;
  background-color: #1f5fff;
  transform: translateY(-50%);
  transition: all 0.4s ease;
}

.icon-container {
  position: absolute;
  left: 4px;
  top: 55%;
  width: 32px;
  height: 32px;
  line-height: 22px;
  transform: translateY(-50%);
  transition: transform 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.svg-icon {
  fill: #fff;
}

.word {
  margin-left: 44px;
  font-weight: 500;
  // color: #fff;
  color: #3784ff;
  transition: color 0.3s;
}

.logo-box {
  display: flex;
  align-items: center;
  justify-content: center;
  // gap: 8px;

  .logo-text-box {
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    // align-items: flex-start;

    .logo-text {
      font-size: 18px;
      font-weight: bold;
      color: #333;
    }

    .logo-text-zm {
      font-size: 12px;
      color: #444;
    }
  }
}

.btn-login {
  height: 36px;
  line-height: 34px;
  font-size: 16px;
  padding: 0 22px;
  color: #3784ff;
  border: 1px solid #3784ff;
  transition: all .3s;
  margin-left: 50px;
  margin-right: 10px;
  border-radius: 2px !important;

  &:hover,
  &.active {
    color: #1B60FD;
    // border: 2px solid #1B60FD;
  }
}

.btn-register {
  height: 36px;
  line-height: 34px;
  font-size: 16px;
  padding: 0 22px;
  color: #fff;
  background-color: #3784ff;
  border: 1px solid #3784ff;
  transition: all .3s;
  margin-left: 10px;
  border-radius: 2px !important;

  &:hover,
  &.active {
    color: #fff;
    background-color: #1B60FD;
    border-color: #1B60FD;
  }
}
</style>
